import { getPostboxContractDocumentsEndpoint, PostboxDocument } from '@cp-es/common';
import { AbstractDataState, useGetContractBasedApiData, useGetSimpleApiData } from '@cp-shared-10/frontend-integration';
import { fetchPostbox } from './PostboxSlice';
import { fetchContractPostbox } from './PostboxContractSlice';
import { PostboxContractDataSelector, PostboxDataSelector } from './PostboxDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-10/common-utilities';

export function usePostbox(): AbstractDataState<PostboxDocument[], DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchPostbox, PostboxDataSelector, true);
}

export function useContractPostbox(
    contractId: string,
): AbstractDataState<PostboxDocument[], DefaultBusinessMarketApiErrorCode> {
    return useGetContractBasedApiData(
        contractId,
        fetchContractPostbox,
        PostboxContractDataSelector,
        getPostboxContractDocumentsEndpoint(contractId),
    );
}
